import { render, staticRenderFns } from "./readonlyaccount.vue?vue&type=template&id=bfd6b73a&"
import script from "./readonlyaccount.vue?vue&type=script&lang=js&"
export * from "./readonlyaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports